import styled from 'styled-components'
import { DefaultFontStyle } from '../../styles/global-styles'

export const HeroBannerContainter = styled.div`
  ${DefaultFontStyle}
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
  text-align: center;
  background: #d82036;
  color: ${props => props.theme.colours.white};
  padding: 84px 0;
`

export const Heading = styled.h2`
  font-size: 36px;
  line-height: 44px;
  font-weight: 500;
  margin: 0;
`

export const SubHeading = styled.p`
  font-size: 15px;
  line-height: 18px;
  font-weight: 400;
  margin: 0;
`

export const SupportingText = styled.p`
  font-size: 16px;
  line-height: 22px;
  font-weight: 400;
  margin: 0;
  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    font-size: 21px;
  }
`
